/**
 * Internal dependencies
 */
import './store';

export { default as DotTip } from './components/dot-tip';
